import { openWorkspace } from '@kc/core/workspace'
import type { Workspace } from '@kc/core/workspace'
import type { Plan } from '@kc/core/review/plan'
import type { RawFile } from '@kc/core/ports'

import { createBrowserPorts, type BrowserPortsBundle } from './browser-ports'
import { ContentFilesPort } from './files-port'

export interface ReviewRuntime extends BrowserPortsBundle {
  readonly workspace: Workspace
}

/**
 * 用当前内容包打开核心 Workspace：
 * FilesPort 提供 Markdown，ReviewLogPort 提供历史，openWorkspace 内部 reload 后折叠出 states。
 * 内容更新时调用方先 files.setFiles(files)，再 workspace.reload()。
 */
export async function openReviewWorkspace(files: readonly RawFile[]): Promise<ReviewRuntime> {
  const filesPort = new ContentFilesPort(files)
  const bundle = createBrowserPorts(filesPort)
  const workspace = await openWorkspace(bundle.ports)
  return { ...bundle, workspace }
}

export function buildTodayPlan(runtime: ReviewRuntime, limit = 20): Plan {
  return runtime.workspace.plan({ kind: 'due', limit })
}
